import { DragDropContext, Droppable, Draggable, DropResult } from '@hello-pangea/dnd';
import { DraggableCard } from '@/components';
import { ProjectDto } from '@/core';
import { findTableNameById } from './helpers';
import classes from './SheetFormTables.module.scss';

type SheetFormTablesProps = {
  tables: string[];
  handleDeleteTable: (table: string) => void;
  droppableId: string;
  projectData: ProjectDto;
  handleDragTable: (tables: string[]) => void;
};

export const SheetFormTables = ({
  tables,
  handleDeleteTable,
  droppableId,
  projectData,
  handleDragTable,
}: SheetFormTablesProps) => {
  const orderedTables = [...tables];

  const handleDragEnd = (result: DropResult) => {
    const { source, destination } = result;

    if (!result.destination) {
      return;
    }

    const [removed] = orderedTables.splice(source?.index!, 1);
    orderedTables.splice(destination?.index!, 0, removed);
    handleDragTable(orderedTables);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId={droppableId} direction="vertical">
        {(provided, snapshot) => (
          <div {...provided.droppableProps} ref={provided.innerRef} className={classes.tablesList}>
            <div className={classes.tableWrapper}>
              {orderedTables.map((table, index) => (
                <Draggable key={table} draggableId={table} index={index}>
                  {(provided, snapshot) => (
                    <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                      <DraggableCard
                        isDeletable
                        isDraggable
                        handleDelete={() => handleDeleteTable(table)}
                        cardText={findTableNameById(table, projectData)}
                        isDragging={snapshot.isDragging}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
